import React from "react";
import { LicenseExpiredAlertMessage } from "@rl-appliances/component-library";
import { BrowserTitle } from "../../../components/BrowserTitle";
import { PAGE_TITLE } from "../../../titles";
import { route } from "../../../shim/jsbridge";

const LicenseExpiredContainer = () => (
  <BrowserTitle title={PAGE_TITLE.LICENSE_EXPIRED}>
    <div className={"Licensing--container LicensingExpired--container"}>
      <LicenseExpiredAlertMessage
        onLogoutClick={() => (window.location = route("logout_login"))}
      />
    </div>
  </BrowserTitle>
);

export default LicenseExpiredContainer;
